import { useEffect } from 'react';

export default function BackendErrorHandler({ error, setError, clearErrors }) {
  useEffect(() => {
    clearErrors();

    if (!error) return;

    // Handle legacy error.data.errors structure
    if (error.data?.errors) {
      const errors = { ...error.data.errors };
      Object.entries(errors).forEach(([field, messages]) => {
        if (Array.isArray(messages)) {
          messages.forEach(msg => {
            setError(field, { type: 'server', message: msg }, { shouldFocus: true });
          });
        }
      });
    }

    // Handle GraphQL errors
    if (Array.isArray(error.graphQLErrors)) {
      error.graphQLErrors.forEach(err => {
        const validation = err?.extensions?.validation;
        if (validation) {
          Object.entries(validation).forEach(([field, messages]) => {
            setError(field, {
              type: 'server',
              message: messages[0], // take first message
            }, { shouldFocus: true });
          });
        }
      });
    }
  }, [error, setError, clearErrors]);

  return null;
}
